import React from "react";
import { Button,  Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import "./IsolationHardwareActionCell.css";

const IsolationHardwareActionCell = props => (
  <Row style={{ display: "block" }}>
    <div className="floatRight">
    <Button
      className="btn-red btn-sm"
      onClick={event => {
        event.stopPropagation();
        props.onDelete();
      }}
    >
      <FontAwesomeIcon icon={faTrash} size="1x" />
    </Button>
    </div>
  </Row>
);

export default IsolationHardwareActionCell;
